export class PaymentModel {
  id: string;
  orderId: string;
  cashId: string;
  companyCode: string;
  storeCode: string;
  paymentMethod: TypePaymentMethodEnum;
  amount: number;
  createdAt: Date;

  constructor(data: Partial<any> = {}) {
    this.id = data.id;
    this.orderId = data.orderId;
    this.cashId = data.cashId;
    this.companyCode = data.companyCode;
    this.storeCode = data.storeCode;
    this.paymentMethod = data.paymentMethod;
    this.amount = Number(data.amount ?? 0);
    this.createdAt = new Date(data.createdAt);
  }
}

export enum TypePaymentMethodEnum {
  CASH = "CASH",
  CARD = "CARD",
  TRANSFER = "TRANSFER",
}

export enum TypeDiscountEnum {
  FLAT = "FLAT",
  PERCENT = "PERCENT",
}

export const PAYMENT_METHOD_LABELS: Record<TypePaymentMethodEnum, string> = {
  [TypePaymentMethodEnum.CASH]: "Efectivo",
  [TypePaymentMethodEnum.CARD]: "Datáfono",
  [TypePaymentMethodEnum.TRANSFER]: "Transferencia",
};
